import React, { ReactNode } from "react";
import { Box } from "@mui/joy";
import { SxProps } from "@mui/system";

interface PageProps {
  children: ReactNode;
  className?: string;
  sx?: SxProps;
}

const Page: React.FC<PageProps> = ({ children, className = "", sx = {} }) => {
  return (
    <Box
      className={className}
      sx={{
        width: "100%",
        maxWidth: "1200px",
        mx: "auto",
        px: { xs: 2, sm: 3 },
        py: 3,
        minHeight: "100%",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default Page;
